<template>
    <div class="st-toast container" :class="enterClass" v-show="selfToastShow">
        <div class="page st-toast_mask" @click="closeToast">
            <!-- banner广告 -->
            <st-ad v-if="bottomBanner" class="st-toast-bottom-banner" adkey="text_banner"></st-ad>
        </div>
        <template v-if="whereClose == 'full'">
            <!-- 全局可关闭需要对子页面进行pointer包裹 -->
            <div class="page pointer">
                <slot>
                    <!-- 处理子elems嵌套 -->
                    <elem v-for="(elem, index) in elems" 
                        :key="'toast_sub_elems_' + index"
                        :mode="elem"
                        :currentPhoto="currentPhoto"
                        :currentTime="currentTime"
                        :canIShow="canToastShow"
                        :currentImage="currentImage"
                        :scene="scene"
                        :line="line"></elem>
                </slot>
            </div>
        </template>
        <template v-else>
            <slot>
                <!-- 处理子elems嵌套 -->
                <elem v-for="(elem, index) in elems" 
                    :key="'toast_sub_elems_' + index"
                    :mode="elem"
                    :currentPhoto="currentPhoto"
                    :currentTime="currentTime"
                    :canIShow="canToastShow"
                    :currentImage="currentImage"
                    :scene="scene"
                    :line="line"></elem>
            </slot>
        </template>
    </div>
</template>

<script>
import BaseElem from '../StElem/BaseElem'
export default {
    name: "st-toast",
    extends: BaseElem,
    data () {
        return {
            canToastShow: false
        }
    },
    model: {
        prop: "canIShow",
        event: "changeShowStatus"
    },
    props: {
        canIShow: {
            default: false,
        },
        whereClose: {
            type: String,
            default: 'mask'
        },
        enterClass: {
            type: String,
            default: "fadeIn"
        },
        closeLog: {
            type: Function
        },
        bottomBanner: {
            type:Boolean,
            default: false
        }
    },
    watch: {
        canIShow: {
            handler (nv, ov) {
                if (nv) {
                    this.$emit("onShow")
                } else {
                    if (ov !== undefined){
                        this.$emit("onHide")
                    }
                }
            },
            immediate: true
        },
        pageDatas: { // 监听控制Toast显示的全局变量
            handler () {
                if (this.isInPage && this.mode && this.mode['id']) {
                    if (this.pageDatas[ this.mode['id'] ]) {
                        this.canToastShow = true;
                    } else {
                        this.canToastShow = false;
                    }
                }
            },
            immediate: true
        },
    },
    mounted () {
        // 初始化支持页面参数唤起toast
        if (this.mode && this.mode['id'] && this.$util.$router.params[ this.mode['id'] ]) {
            this.canToastShow = true;
        }
    },
    computed: {
        selfToastShow () {
            if (this.mode) { // page 模式
                return this.canToastShow;
            } else { // v-model模式
                return this.canIShow;
            }
        },
        config () {
            return (this.mode && this.mode['comp'] && this.mode['comp']['config']) || {};
        },
        selfWhereClose () {
            return this.config.whereClose || this.whereClose;
        },
        selfEnterClass () {
            return this.config.enterClass || this.enterClass;
        }
    },
    methods: {
        closeToast () {
            if (this.whereClose == 'none') {
                return;
            }
            this.$emit("changeShowStatus", false)
            this.closeLog && this.closeLog();
            if (this.mode && this.mode['id']) {
                this.$store.commit("setPageDatas", {
                    key: this.mode['id'],
                    value: 0
                })
            }
        },
    }
}
</script>

<style>
    .st-toast{
        position: fixed;
        z-index: 99;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
    }
    .st-toast_mask {
        background-color: rgba(0, 0, 0, 0.75);
        z-index: -1;
    }
    .st-toast-bottom-banner {
        position: absolute;
        left: 0;
        right: 0;
        bottom: 24px;
        width: 468px;
        border-radius: 8px;
        margin: auto auto 16px;
    }
</style>